export class RefundDetails {
    refundDetailID: number;
    paymentTransID: string;
    OrderID: string;
    InvoiceID: string;
    Agency: string;
    Advertiser: string;
    CreditManagerID: number;
    AdvertiserID: number;
    OrderInvoiceDate: Date;
    OrderInvoiceDateSortable: any;
    RefundApproved: boolean;
    RefundAmount: any;
    ApprovalStatus: string;
    AccountExecutiveComments: string;
    CreditManagerComments: string;
    BalanceAmount: any;
    CreatedDate: Date;
    CreatedBy: string;
    UpdatedDate: Date;
    UpdatedBy: number;
    OriginalApprovalCodeForRefund:string;
}

export interface FinanceVP {
    Id: number;
    Name: string;
}
export class Transaction {
    ID: any;
    Type: string;
    TransactionType: string;
    OrderInvoiceDate: any;
    orderInvoiceDateSortable: any;
    OrderID: string;
    InvoiceID: string;
    PaymentTransID: number;
    Agency: string;
    Advertiser: string;
    Stations: string;
    PaymentTransType: string;
    cardNo: string;
    OrderInvoiceAmount: any;
    AmountPaid: any;
    balanceAmount: any;
    paymentSettlementDate: any;
    paymentSettlementDateSortable: any;
    PaymentBatchID: string;
    PaymentCustomerProfile: string;
    ChaseTransactionDate: any;
    ChaseStatus: string;
    createdDate: any;
    CreatedBy: string;
    userID: any;
    // Arvind Approval code
    ApprovalCode: string;
    // Arvind agencyTCode
    agencyTcode:string;
    Isprocessed : boolean;
    checkedbox :boolean;
    //Arvind Partialpayment
    PartialPayment:any;
    // Arvind for Agency commission percentage
    AgencyCommission : any;
    AdvanceTax : any;
    tax : any;
    stations : any;
    ledgerAmount: any;
    // original approval code
    originalApprovalCode :any;
}
export enum Period {
    ThreeMonths = '3 Months',
    SixMonths = '6 Months',
    OneYear = '1 Year',
    SelectPeriod = 'Select Period',
    All = 'All'
}

export class CommentsDetails {
    Comments: string;
    FirstName: string;
    LastName: string;
    UpdatedBy: string;
    CommentsDate: string;

}

export class CommentsModel {
    RefundDetailID: number;
    UserId: number;
    RoleID: number;
    ActionID: number;
    Comments: string;
}


export class RefundDetailsModel {
    OrderID: string;
    InvoiceID: string;
    PaymentTransID: string;
    RefundDetailID: number;
    CreditManagerID: number;
    OrderInvoiceDate: Date;
    AgencyID: number;
    AdvertiserID: number;
    RefundApproved: number;
    RefundAmount: string;
    ApprovalStatus: string;
    AccountExecutiveComments: string;
    CreatedDate: Date;
    CreatedBy: string;
    RoleID: number;
    ActionID: number;
    // Arvind for original approval code for refund
    OriginalApprovalCodeForRefund:string;
}

// Arvind for date calendar
export class Calendar {

    value1: Date;
    value2: Date;

}


// WEBPACK FOOTER //
// ./src/app/account-executive/Model/AccountExecutive.ts